export const formatTime = ms => {
  const clamped = Math.max(0, ms)
  
  const millis = (clamped % 1000).toString().padStart(3, '0');
  const seconds = Math.floor((clamped / 1000) % 60).toString().padStart(2, '0');
  const minutes = Math.floor((clamped / 60000) % 60).toString().padStart(2, '0');
  const hours = Math.floor((clamped / 3600000) % 24).toString().padStart(1, '0');
  
  return [millis, seconds, minutes, hours];
}

export const isMetaPage = relativePath => {
  // Namespace listing at
  // https://en.wikipedia.org/wiki/Wikipedia:Namespace
  const path = relativePath.replace(/^(?:.*\/)?/, '/');
  return (
    path.startsWith('/wiki/User:') ||
    path.startsWith('/wiki/Wikipedia:') ||
    path.startsWith('/wiki/File:') ||
    path.startsWith('/wiki/MediaWiki:') ||
    path.startsWith('/wiki/Template:') ||
    path.startsWith('/wiki/Help:') ||
    path.startsWith('/wiki/Category:') ||
    path.startsWith('/wiki/Portal:') ||
    path.startsWith('/wiki/Draft:') ||
    path.startsWith('/wiki/TimedText:') ||
    path.startsWith('/wiki/Module:') ||
    path.startsWith('/wiki/Gadget:') ||
    path.startsWith('/wiki/Special:') ||
    path.startsWith('/wiki/Media:')
  );
}

export const isBruhName = name => {
  return (
    name.toLowerCase().includes('iiro') ||
    name.toLowerCase().includes('iibae') ||
    name.toLowerCase().includes('luttinen') ||
    (name.toLowerCase().includes('atte') && name.toLowerCase().includes('mother')) ||
    (name.toLowerCase().includes('atte') && name.toLowerCase().includes('motter')) ||
    (name.toLowerCase().includes('atte') && name.toLowerCase().includes('mom'))
  );
}
